import './Article.css';

export default function TimeAttackPage() {
  return (
    <article className="Article">
      <h1 className="Article__title">Гонка ​​​​​​Time Attack</h1>
      <p className="Article__paragraph">
        Гонка Time Attack создана для тех, кто любит ставить рекорды – открытое
        соревнование на гражданских автомобилях не предполагает контактной
        борьбы пилотов во время заезда, но позволит в полной мере ощутить
        скорость, найти идеальную траекторию и реализовать весь потенциал своего
        автомобиля. Каждый участник проезжает по Сочи Автодрому определённое
        количество кругов, а в зачёт идёт только лучшее время одного круга из
        всех заездов. Для того, чтобы попробовать свои силы на лучшей гоночной
        трассе страны, Вам понадобится исправный легковой автомобиль на летних
        шинах и шлем.
      </p>
    </article>
  );
}
